// #region Import
import { CookieStorage } from 'cookie-storage';
// #endregion
export default class CookieFactory {
    // #region Vars
    _cookies;
    // #endregion
    // #region Constructor
    constructor() {
        this._cookies = new CookieStorage({
            path: appHost.config.cookiePath,
            secure: false, // only allow HTTPs
            sameSite: 'Strict' // Should be Strict
        });
    }
    // #endregion
    // #region Core
    getItem(name) {
        return this._cookies.getItem(name);
    }
    removeItem(name) {
        return this._cookies.removeItem(name);
    }
    setItem(name, content, expirationDays = 0) {
        if (utils.isEmpty(content)) {
            this._cookies.removeItem(name);
        }
        else {
            if (expirationDays > 0) {
                this._cookies.setItem(name, content ?? '', { expires: new Date(Date.now() + ((expirationDays ?? 0) * 24 * 60 * 60 * 1000)) });
            }
            else {
                this._cookies.setItem(name, content ?? '');
            }
        }
    }
}
